import { api } from "./client";

const users = {
  list: () => api.get("/users"),
  create: (data) => api.post("/users", data),
  update: (id, data) => api.patch(`/users/${id}`, data),
  remove: (id) => api.delete(`/users/${id}`),
  // Self-service onboarding flag (used by the OnboardingTour).
  setOnboardingCompleted: (completed = true) =>
    api.patch("/users/me/onboarding", { completed }),
};

export default users;
